import React from 'react';
import { useAuth } from '../store/AuthContext';
import { useLocation, Navigate } from 'react-router-dom';

const withComponentAuth = (
  WrappedComponent: () => JSX.Element,
): (() => JSX.Element) => {
  return (): JSX.Element => {
    const { verify, authState } = useAuth();
    const location = useLocation();

    // only check after authState initialized
    const isAuthenticated = verify().isAuthentic && authState.isLoggedIn;

    if (!isAuthenticated) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <WrappedComponent />;
  };
};

export default withComponentAuth;
